import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Textarea,
  useToast,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';

import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import {
  editGoalItem,
  getGoalCategories,
} from '../../stores/slices/goals/goalsActions';
import * as yup from 'yup';

const schema = yup
  .object({
    goalItem: yup.string().required('Description is required'),
    goalStatus: yup.string().required('Status is required'),
  })
  .required();

const EditGoalItem = ({ isOpen, onClose, openComments, goal, category }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSaveItem = async data => {
    await dispatch(
      editGoalItem({
        ...data,
        goalCategoryId: category.id,
        goalId: goal.id,
      })
    );
    await dispatch(getGoalCategories());
    reset();
    onClose();
    toast({
      description: 'Item has been updated',
      colorScheme: 'primary',
      status: 'success',
      duration: 3000,
      isClosable: true,
      position: 'bottom-right',
      variant: 'primary',
    });
  };
  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={onClose}
      blockScrollOnMount={openComments ? false : true}
    >
      <ModalOverlay />
      <ModalContent>
        <form onSubmit={handleSubmit(onSaveItem)}>
          <ModalHeader>Edit an Item</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl id="goalItem" isInvalid={errors.goalItem} mb={'4'}>
              <FormLabel>Item Description</FormLabel>
              <Textarea
                id="goalItem"
                defaultValue={goal.text}
                {...register('goalItem')}
                autoFocus
                rows={'4'}
              />
              <FormErrorMessage>
                {errors.goalItem && errors.goalItem.message}
              </FormErrorMessage>
            </FormControl>
            <FormControl id="goalStatus" isInvalid={errors.goalStatus}>
              <FormLabel>Status</FormLabel>
              <Select
                placeholder="Select option"
                id="goalStatus"
                defaultValue={goal.status}
                {...register('goalStatus')}
              >
                <option value="In Progress">In Progress</option>
                <option value="Complete">Complete</option>
                <option value="Archived">Archived</option>
              </Select>
              <FormErrorMessage>
                {errors.goalStatus && errors.goalStatus.message}
              </FormErrorMessage>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button mr={3} type="submit" isLoading={isSubmitting}>
              Save
            </Button>
            <Button onClick={onClose} variant="outline" disabled={isSubmitting}>
              Cancel
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default EditGoalItem;
